import { Flex, Typography } from '@iheartjane/reefer';
import { useMemo } from 'react';

import { FlavorCard } from '@jane/shared-ecomm/components';
import type { FlavorEnum } from '@jane/shared/types';

import { ProductDetailsSection } from '../ProductDetailsSection/ProductDetailsSection';

interface FlavorSectionProps {
  flavors: {
    count: number;
    value: FlavorEnum;
  }[];
}

export const FlavorSection = ({ flavors }: FlavorSectionProps) => {
  const total = useMemo(
    () => flavors.reduce((prev, curr) => prev + curr.count, 0),
    [flavors]
  );

  return (
    <ProductDetailsSection
      ariaLabel="product flavors section"
      title="Top flavors"
      isLoading={false}
    >
      <Flex
        justifyContent="center"
        flexDirection="row"
        flexWrap="nowrap"
        width="100%"
        gap={16}
      >
        {flavors.map(({ count, value }) => {
          const widthPercentage = (count / total) * 100;

          return (
            <FlavorCard
              key={value}
              flavor={value}
              typography={Typography}
              width={`${widthPercentage}%`}
            />
          );
        })}
      </Flex>
    </ProductDetailsSection>
  );
};
